export default __webpack_public_path__ + "static/media/gb-sct.4286a3d9.svg";